// イベント詳細 チェックイン
export const getUniqeStringArray = (srtingArray: string[]) => {
  const uniqueStringArray = [...new Set(srtingArray.filter((name) => !!name))]
  return uniqueStringArray
}
